/**
 * Plattform-Detection. Wird genutzt, um Features bedingt zu rendern, die
 * iOS-spezifisch sind (z. B. Apple-Shortcuts-Deep-Link).
 *
 * SSR-safe: returnt false wenn navigator fehlt.
 */

export function isIOS(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  if (/iPad|iPhone|iPod/.test(ua)) return true;
  // iPadOS 13+ reportet sich als macOS, hat aber Multi-Touch.
  // navigator.maxTouchPoints > 0 ist die moderne, zuverlaessige Touch-Detection.
  if (/Mac/.test(ua) && typeof navigator.maxTouchPoints === 'number' && navigator.maxTouchPoints > 0) {
    return true;
  }
  return false;
}
